import { useEffect, useState } from 'react';
import MyDiv from './HrManualAssignment.style';
import { CustomTable, CustomToast } from '../../../../components';
import { useFetch } from '../../../../hooks/useFetch';
import { Box, Flex, Grid, GridItem, Text, Button, Checkbox, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Select, ModalCloseButton, Switch } from '@chakra-ui/react';
import { Column } from '../../../../components/CustomTable/customTable';
import { showDate } from '../../../../utilities/helper';

export default function HrManualAssignment() {
    const [tableData, setTableData] = useState<any[]>([]);
    const [selectedCandidates, setSelectedCandidates] = useState<any[]>([]);
    const [selectedHr, setSelectedHr] = useState<any>(null);
    const [targetHr, setTargetHr] = useState<number | null>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [presentHr, setPresentHr] = useState<any[]>([]);
    const [showInactiveHr, setShowInactiveHr] = useState(true);
    const [historyModalOpen, setHistoryModalOpen] = useState(false);
    const [historyData, setHistoryData] = useState<any[]>([]);
    const [historyCandidate, setHistoryCandidate] = useState<string>("");


    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);

    const loadTableData = async () => {
        const response = await fetchApi(`Candidate/absent-recruitment-hrs-today?attendanceStatus=${showInactiveHr}`, "GET");
        if (response) setTableData(response);
    };

    useEffect(() => {
        loadTableData();
        LoadPresentHr();
    }, []);


    const openAssignModal = (hr: any, candidates: any[]) => {
        setSelectedHr(hr);
        setSelectedCandidates(candidates);
        setIsOpen(true);
    };

    const toggleCandidate = (candidate: any) => {
        setSelectedCandidates(prev =>
            prev.some(c => c.candidateId === candidate.candidateId)
                ? prev.filter(c => c.candidateId !== candidate.candidateId)
                : [...prev, candidate]
        );
    };

    const isCandidateSelected = (candidateId: number) => {
        return selectedCandidates.some(c => c.candidateId === candidateId);
    };

    const toggleSelectAll = (checked: boolean) => {
        if (checked) {
            setSelectedCandidates(selectedHr?.assignedCandidates || []);
        } else {
            setSelectedCandidates([]);
        }
    };

    // const toggleSelectAll = (checked: boolean) => {
    //     if (checked) {
    //         const selectable = (selectedHr?.assignedCandidates || [])
    //             .filter((c: any) => !c.disableCheckbox);
    //         setSelectedCandidates(selectable);
    //     } else {
    //         setSelectedCandidates([]);
    //     }
    // };

    const handleAssign = async () => {
        if (!targetHr || selectedCandidates.length === 0) {
            addToast({ message: "Select HR & candidates", status: "warning" });
            return;
        }
        const payload = {
            candidateIds: selectedCandidates.map(c => c.candidateId),
            newHrEmployeeId: targetHr
        };

        const res = await fetchApi("Candidate/manual-reassign-hr-bulk", "POST", payload);

        if (res) {
            addToast({ message: `${selectedCandidates.length} candidate(s) reassigned successfully`, status: "success" });
            setIsOpen(false);
            setSelectedCandidates([]);
            setTargetHr(null);
            loadTableData();
        }
    };

    const LoadPresentHr = async () => {
        const response = await fetchApi("Candidate/present-recruitment-hrs-today", "GET");
        if (response) {
            setPresentHr(response);
        }
    }

    const renderCandidates = (row: any) => {
        if (!row.assignedCandidates?.length) return <Text fontSize="sm" color="gray.500">No candidates</Text>;

        return <Text fontSize="sm" color="gray.500" onClick={() => openAssignModal(row, row.assignedCandidates)}>View Candidate</Text>;
    }

    useEffect(() => {
        loadTableData();
    }, [showInactiveHr]);


    return (
        <MyDiv>
            <Box className="page_wrapper">
                <Flex className="page_heading flex_header">
                    <Text className="font-poppins text_semibold text_3xl">
                        HR Manual Assignment
                    </Text>
                    <Flex className="filter_section">
                        <Flex align="center" gap={2}>
                            <Text color={showInactiveHr ? "red.500" : "green.500"} className="font-poppins text_semibold text_md">
                                {showInactiveHr ? "Inactive HR" : "Active HR"}
                            </Text>
                            <Switch colorScheme="red" isChecked={showInactiveHr} onChange={(e) => { setShowInactiveHr(e.target.checked); }} />
                        </Flex>
                    </Flex>
                </Flex>

                <Grid className="grid_container">
                    <GridItem colSpan={12}>
                        <CustomTable value={tableData} loading={loading}>
                            <Column header="S.No" body={(_, i) => i + 1} />
                            <Column header="HR Name" field="hrName" />
                            <Column header="Company Name" field="company_Name" />
                            <Column header="Branch Name" field="branch_Name" />
                            <Column header="Assigned Candidates" body={renderCandidates} />

                        </CustomTable>
                    </GridItem>
                </Grid>
            </Box>

            <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} size="6xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalCloseButton />
                    <ModalHeader>Manual Reassignment</ModalHeader>
                    <ModalBody>
                        <Box mb={4}>
                            <Text mb={1} fontWeight="500">Assign To HR</Text>
                            <Select placeholder="Select HR" value={targetHr ?? ""} onChange={(e) => setTargetHr(Number(e.target.value))} >
                                {presentHr.map(hr => (
                                    <option key={hr.hrEmployeeId} value={hr.hrEmployeeId}>
                                        {hr.hrName}
                                    </option>
                                ))}
                            </Select>
                        </Box>

                        <Box border="1px solid #e2e8f0" borderRadius="8px" overflow="hidden">
                            <CustomTable value={selectedHr?.assignedCandidates || []} loading={false} emptyMessage="No candidates available." >
                                <Column
                                    header={
                                        <Checkbox
                                            isChecked={
                                                selectedCandidates.length > 0
                                                //  &&
                                                // selectedCandidates.length ===
                                                // selectedHr?.assignedCandidates?.filter((c: any) => !c.disableCheckbox).length
                                            }
                                            isIndeterminate={
                                                selectedCandidates.length > 0
                                                //  &&
                                                // selectedCandidates.length <
                                                // selectedHr?.assignedCandidates?.filter((c: any) => !c.disableCheckbox).length
                                            }
                                            onChange={(e) => toggleSelectAll(e.target.checked)}
                                        />
                                    }



                                    body={(row: any) => (<Checkbox isChecked={isCandidateSelected(row.candidateId)} onChange={() => toggleCandidate(row)} />)}
                                />

                                <Column header="Candidate Name" field="candidateName" />
                                <Column
                                    header="Assignment Info"
                                    body={(row: any) =>
                                        row.isManuallyAssigned ? (
                                            <Text fontSize="sm" color="red.500" fontWeight="600">
                                                Manually assigned to {row.manuallyAssignedToHrName}
                                            </Text>
                                        ) : (
                                            <Text fontSize="sm" color="green.500">
                                                Auto Assigned
                                            </Text>
                                        )
                                    }
                                />
                                <Column header="Email" field="candidateEmail" />
                                <Column header="Job Code" field="jobCode" />
                                <Column header="Job Profile" field="jobProfile" />
                                <Column header="Company" field="companyName" />
                                <Column header="Branch" field="branchName" />
                                <Column header="Payroll" field="payrollCompany" />
                                <Column
                                    header="History"
                                    body={(row: any) => (
                                        <Button
                                            size="xs"
                                            colorScheme="blue"
                                            variant="outline"
                                            onClick={() => {
                                                setHistoryCandidate(row.candidateName);
                                                setHistoryData(row.assignmentHistory || []);
                                                setHistoryModalOpen(true);
                                            }}
                                        >
                                            View
                                        </Button>
                                    )}
                                />
                            </CustomTable>
                        </Box>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme="green" onClick={handleAssign}>Assign Selected</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal isOpen={historyModalOpen} onClose={() => setHistoryModalOpen(false)} size="md">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        Assignment History – {historyCandidate}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {historyData.length === 0 ? (
                            <Text>No history available</Text>
                        ) : (
                            historyData.map((h, i) => (
                                <Box key={i} p={3} mb={2} borderRadius="md" bg={h.type === "AUTO" ? "green.50" : "red.50"} >
                                    <Text className="font-poppins text_semibold text_lg"   >
                                        {h.type === "AUTO" ? "Auto Assigned" : "Manually Assigned"}
                                    </Text>
                                    <Text className="font-poppins  text_md">HR: <b>{h.assignedToHrName}</b></Text>
                                    <Text className="font-poppins  text_sm" color="gray.600">Assigned At:  {showDate(h.assignedAt)}</Text>
                                </Box>
                            ))
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>

        </MyDiv >
    );
}

